import { render, staticRenderFns } from "./commissioniProdottiCommerciali.vue?vue&type=template&id=504446e2&"
import script from "./commissioniProdottiCommerciali.vue.ts?vue&type=script&lang=ts&"
export * from "./commissioniProdottiCommerciali.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports